import { Button, Col, Dropdown, Form, Input, InputRef, Menu, PaginationProps, Row, Select, Space, Tag, Typography, DatePicker } from 'antd'
import { ColumnType } from 'antd/es/table'
import React, { useCallback, useEffect, useMemo } from 'react'
import { AiOutlineClear, AiOutlineExport, AiOutlinePrinter, AiOutlineSearch } from 'react-icons/ai'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { filterFunction } from '../../../common/SearchFilterComponent'
import { ICreditNoteContext, ICreditNoteWaybills, ISearchCnDnRequest } from '../../../model/CNDNModel'
import { useCNDNStore } from '../../../stores/CNDNStore'
import { DD_MM_YYYY_H_MM, DEFAULT_CURRENT, DEFAULT_PAGE_SIZE, Employee, TWO_HUNDRED_SUCCESS_CODE, UserEnum, accountListMap, dropDownMapping, isAccessible, isProdMode } from '../../../utils/app-common'
import { PRICING_TEAM_ACCESS } from '../../../utils/access-list'
import { convertDateFromMillis } from '../../../utils/luxon'
import BtnComponent from '../BtnComponent'
import { expandedRowRender } from '../ExpandedRowRender'
import CreditNoteCreateComponent from './CreditNoteCreateComponent'
import { useBookingStore } from '../../../stores/BookingStore'
import { IBookingState } from '../../../model/BookingModel'
import { useUserContextHook } from '../../../hooks/useUserContextHook'
import { useCommonStore } from '../../../stores/CommonStore'
import { ICommonState } from '../../../model/CommonModel'
import PaginatedTableComponent from '../../CommonComponent/PaginatedTableComponent'
import dayjs, { Dayjs } from 'dayjs'

export const CreditNoteContext = React.createContext({} as ICreditNoteContext);
export const expandedRowClassName = () => 'expanded-row'

const SearchComponent = () => {
  const [form] = Form.useForm();
  const { employeeDetail } = useUserContextHook() || {};
  const GetCNDNWaybillAction = useCNDNStore(state => state?.GetCNDNWaybillAction);
  const FilterCNDNWaybillAction = useCNDNStore(state => state?.FilterCNDNWaybillAction);
  const getCustomerAction = useBookingStore(
    (state: IBookingState) => state?.GetCustomerByIdAction
  );
  const { promiseInProgress: getCNProgress } = usePromiseTracker({ area: 'get-cn-area' });
  const GetIndustriesGroupList = useCommonStore((state: ICommonState) => state?.GetIndustriesGroupListAction);
  const accountsList = useBookingStore((state) => state.accountList);
  const industryGroupList = useCommonStore((state: ICommonState) => state?.industryGroupList);
  const accountsListMemo = useMemo(
    () =>
      accountListMap(accountsList, "subClientId", "accountId", "accountName"),
    [accountsList]
  );
  const industryGroupListMemo = useMemo(() => dropDownMapping(industryGroupList, 'id', 'name'), [industryGroupList]);
  useEffect(() => {
    getCustomerAction(employeeDetail?.employeeId!, true);
    GetIndustriesGroupList();
  }, [employeeDetail?.employeeId, getCustomerAction]);

  const onSearchHandler = (values: ISearchCnDnRequest) => {


  let fromDate: number | undefined;
    let toDate: number | undefined;
    if (values?.dateRange) {
      fromDate = dayjs(values.dateRange[0]).startOf('day').valueOf();
      // next-day midnight so the backend's exclusive toDate includes the full day
      toDate = dayjs(values.dateRange[1]).add(1, 'day').startOf('day').valueOf();
    }

    let fromApprovalDate: number | undefined;
    let toApprovalDate: number | undefined;
    let approvalDateType: string | undefined; 
    if (values?.approvalDateRange) {
      fromApprovalDate = dayjs(values.approvalDateRange[0]).startOf('day').valueOf();
      // next-day midnight so the backend's exclusive toDate includes the full day
      toApprovalDate = dayjs(values.approvalDateRange[1]).add(1, 'day').startOf('day').valueOf();

      approvalDateType = 'CFO'; 
    }




    const request: ISearchCnDnRequest = {
      subClientId: values?.subClientId,
      industryGroupId: values?.industryGroupId,
      waybillNo: values?.waybillNo
    };
 trackPromise(FilterCNDNWaybillAction({ isDirectorConfirmedSet: false, isFinanceConfirmedSet: false, customer: request?.subClientId, industryGroup: request?.industryGroupId, waybillNo: request?.waybillNo ,  fromDate,
    toDate , fromApprovalDate, toApprovalDate , approvalDateType }), "get-cn-area");  };

  const onClearHandler = () => {
    form.setFieldsValue({
      subClientId: "",
      industryGroupId: "",
       waybillNo: "",
      dateRange: undefined,
      approvalDateRange: undefined
    });
    trackPromise(GetCNDNWaybillAction({ isDirectorConfirmedSet: false, isFinanceConfirmedSet: false, isCfoConfirmedSet: false, isDivisionHeadConfirmedSet: false }), 'get-cn-area');
  };

  return (
    <Form
      form={form}
      onFinish={onSearchHandler}
      initialValues={{ subClientId: "", industryGroupId: "", waybillNo: "", dateRange: undefined, approvalDateRange: undefined  }}
      autoComplete="off"
    >
      <Row gutter={4} justify={"start"} align={"middle"}>
        <Col span={5}>
          <Form.Item
            name="subClientId"
            label="Customer Account"
            labelCol={{ span: 24 }}
          // rules={[numericValidation]}
          >
            <Select
              // disabled={disabledField?.subClientId}
              showSearch
              allowClear
              // loading={customerProgress}
              // onSelect={onDropdownHandler}
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  ?.toLocaleLowerCase()
                  ?.includes(input?.toLocaleLowerCase())
              }
            >
              {accountsListMemo?.map((customer, index) => (
                <React.Fragment key={customer?.id}>
                  <Select.Option value={customer?.id} key={customer?.id}>
                    {customer?.value}
                  </Select.Option>
                </React.Fragment>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            name="industryGroupId"
            label="Industry Group"
            labelCol={{ span: 24 }}
          >
            <Select
              // disabled={disabledField?.subClientId}
              showSearch
              allowClear
              // loading={customerProgress}
              // onSelect={onDropdownHandler}
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  ?.toLocaleLowerCase()
                  ?.includes(input?.toLocaleLowerCase())
              }
            >
              {industryGroupListMemo?.map((customer, index) => (
                <React.Fragment key={customer?.id}>
                  <Select.Option value={customer?.id} key={customer?.id}>
                    {customer?.value}
                  </Select.Option>
                </React.Fragment>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            name="waybillNo"
            label="Waybill No"
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
        </Col>



    <Col span={6}>
          <Form.Item
            name="dateRange"
            label="Created Date"
            labelCol={{ span: 24 }}
          >
            <DatePicker.RangePicker allowClear style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="approvalDateRange"
            label="Final Approval Date"
            labelCol={{ span: 24 }}
          >
            <DatePicker.RangePicker allowClear style={{ width: '100%' }} />
          </Form.Item>
        </Col>


        <Col>
          <Button
            loading={getCNProgress}
            htmlType="submit"
            icon={<AiOutlineSearch size={20} />}
            className="margin-top-1rem icon-button"
          />
        </Col>
        <Col>
          <Button
            loading={getCNProgress}
            htmlType="button"
            icon={<AiOutlineClear size={20} />}
            className="margin-top-1rem icon-button"
            onClick={onClearHandler}
          />
        </Col>
      </Row>
    </Form>
  );
};


const ExportVehicleToExcelComponent = ({
  onExportToExcelVehicleHandle,
}: {
  onExportToExcelVehicleHandle: () => void;
}) => {
  const { promiseInProgress: downloadExcel } = usePromiseTracker({ area: 'download-file-area' });
  return (
    <Button
      onClick={onExportToExcelVehicleHandle}
      className="icon-button"
      icon={<AiOutlineExport size={18} />}
    >
      Export To Excel
    </Button>
  );
};

export const useCreditNoteContextHook = () => {
  // get the context
  const context = React.useContext(CreditNoteContext);
  // if `undefined`, throw an error
  if (!context) {
    throw new Error("CreditNoteContext was used outside of its Provider");
  }
  return context;
};


export const MenuListComponent = ({ record }: { record: ICreditNoteWaybills }) => {
  const PrintCreditNoteAction = useCNDNStore(state => state?.PrintCreditNoteAction);
  const approveCreditNoteResponse = useCNDNStore(state => state?.approveCreditNoteResponse);

  const onPrintHandler = React.useCallback(() => trackPromise(PrintCreditNoteAction(record?.id), 'print-debit-note-area'), [PrintCreditNoteAction, record?.id])
  React.useEffect(() => {
    if (approveCreditNoteResponse === TWO_HUNDRED_SUCCESS_CODE) {
      useCNDNStore.setState({ approveCreditNoteResponse: undefined })
    }

  }, [approveCreditNoteResponse])

  const isPrintAccessible = !isProdMode() ?
    isAccessible([Employee.PRANEETH_DEV], [], true)
    : isAccessible([...PRICING_TEAM_ACCESS, Employee.GOIUSE, Employee.GOPINATH], [], true);

  const items = [
    ...(isPrintAccessible ? [{
      key: 1,
      icon: <AiOutlinePrinter size={18} />,
      label: 'Print',
      disabled: (Boolean(record?.approvedById)),
      onClick: onPrintHandler
    }] : []),
  ]
  return (
    <Menu
      items={items}
    />
  )
}
export default function CreditNoteTableComponent() {

  const searchInput = React.useRef<InputRef>(null);
  const getColumnSearchProps = (dataIndex: string): ColumnType<ICreditNoteWaybills> => filterFunction(dataIndex, searchInput);

  const { promiseInProgress: getCNProgress } = usePromiseTracker({ area: 'get-cn-area' });
  const { promiseInProgress: getCreditNotePrintProgress } = usePromiseTracker({ area: 'get-cn-print-area' });
  const GetCNDNWaybillAction = useCNDNStore(state => state?.GetCNDNWaybillAction);
  const waybillsState = useCNDNStore(state => state?.waybills);
  const total = useCNDNStore(state => state?.total);
  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(false);
  const [subClientId, setSubClientId] = React.useState<number | undefined>(undefined)
  const [selectedWaybill, setSelectedWaybill] = React.useState<string | undefined>(undefined)
  const { waybills } = waybillsState || {};

  const ExportCnDnToExcelAction = useCNDNStore(
    (state) => state?.ExportCnDnToExcelAction
  );

  const [current, setCurrent] = React.useState<number>(DEFAULT_CURRENT);
  const [pageSize, setPageSize] = React.useState<number>(DEFAULT_PAGE_SIZE);

  const onClickHandler = () => {
    useCNDNStore.setState({ search: [], creditNoteResponse: undefined });
    setOpen(true)
  }
  const getRecord = React.useCallback((pageNumber: number, pageSize: number) => {
    trackPromise(GetCNDNWaybillAction({ pageNumber: pageNumber, pageSize: pageSize, isDirectorConfirmedSet: false, isFinanceConfirmedSet: false, isCfoConfirmedSet: false, isDivisionHeadConfirmedSet: false }), 'get-cn-area');
  }, [GetCNDNWaybillAction])

  React.useEffect(() => {
    getRecord(DEFAULT_CURRENT, DEFAULT_PAGE_SIZE);
  }, [getRecord])

  const columns = React.useMemo(() => [
    {
      title: 'CN/DN Request Number',
      dataIndex: 'cndnRequestNo',
      key: 'cndnRequestNo',
      width: 20,
      ...getColumnSearchProps('cndnRequestNo')
    }, {
      title: 'Created Date',
      dataIndex: 'createdDate',
      key: 'createdDate',
      width: 20,
      // ...getColumnSearchProps('createdDate'),
      render: (createdDate: number) => convertDateFromMillis(createdDate, DD_MM_YYYY_H_MM)
    }, {
      title: 'created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
      width: 20,
      // ...getColumnSearchProps('createdBy'),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerSubAccount',
      key: 'customerSubAccount',
      width: 20,
      // ...getColumnSearchProps('customerSubAccount'),
    },
    {
      title: 'Customer Account',
      dataIndex: 'customerSubAccountCode',
      key: 'customerSubAccountCode',
      width: 20,
      // ...getColumnSearchProps('customerSubAccountCode'),
    },
    {
      title: 'Industry Group',
      dataIndex: 'industryGroup',
      key: 'industryGroup',
      width: 20,
      // ...getColumnSearchProps('industryGroup'),
    },
    {
      title: 'Director Approval By',
      dataIndex: 'approvedByDirector',
      key: 'approvedByDirector',
      width: 20,
      // ...getColumnSearchProps('approvedByDirector'),
    },
    {
      title: 'Director Approval Date',
      dataIndex: 'approvedByDirectorDate',
      key: 'approvedByDirectorDate',
      width: 20,
      // ...getColumnSearchProps('approvedByDirectorDate'),
      render: (approvedByDirectorDate: number) => convertDateFromMillis(approvedByDirectorDate, DD_MM_YYYY_H_MM)
    },

    {
      title: 'Division Head Approval By',
      dataIndex: 'approvedByDivisionHead',
      key: 'approvedByDivisionHead',
      width: 20,
      // ...getColumnSearchProps('approvedByDivisionHead'),
    },
    {
      title: 'Division Head Approval Date',
      dataIndex: 'approvedByDivisionHeadDate',
      key: 'approvedByDivisionHeadDate',
      width: 20,
      // ...getColumnSearchProps('approvedByDivisionHeadDate'),
      render: (approvedByDivisionHeadDate: number) => convertDateFromMillis(approvedByDivisionHeadDate, DD_MM_YYYY_H_MM)
    },

    {
      title: 'Finance Approval By',
      dataIndex: 'approvedByFinance',
      key: 'approvedByFinance',
      width: 20,
      // ...getColumnSearchProps('approvedByFinance'),
    },
    {
      title: 'Finance Approval Date',
      dataIndex: 'approvedByFinanceDate',
      key: 'approvedByFinanceDate',
      width: 20,
      // ...getColumnSearchProps('approvedByFinanceDate'),
      render: (approvedByFinanceDate: number) => convertDateFromMillis(approvedByFinanceDate, DD_MM_YYYY_H_MM)
    },

    {
      title: 'CFO Approval By',
      dataIndex: 'approvedByCfo',
      key: 'approvedByCfo',
      width: 20,
      // ...getColumnSearchProps('approvedByCfo'),
    },
    {
      title: 'CFO Approval Date',
      dataIndex: 'approvedByCfoDate',
      key: 'approvedByCfoDate',
      width: 20,
      // ...getColumnSearchProps('approvedByCfoDate'),
      render: (approvedByCfoDate: number) => convertDateFromMillis(approvedByCfoDate, DD_MM_YYYY_H_MM)
    },

    {
      title: 'Rejected By',
      dataIndex: 'rejectedBy',
      key: 'rejectedBy',
      width: 20,
      // ...getColumnSearchProps('rejectedBy'),
    }, {
      title: 'remarks',
      dataIndex: 'remarks',
      key: 'remarks',
      width: 20,
      // ...getColumnSearchProps('remarks'),
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'print',
      width: 20,
      render: (text, record: ICreditNoteWaybills) => {
        return (
          <Dropdown.Button
            overlay={<MenuListComponent record={record} />}>
          </Dropdown.Button>
        )
      }
    }], []);

  const onRefreshHandler = useCallback(() => {
    getRecord(DEFAULT_CURRENT, DEFAULT_PAGE_SIZE);
    setCurrent(DEFAULT_CURRENT);
    setPageSize(DEFAULT_PAGE_SIZE);
  }, [getRecord]);

  const onPaginationChange: PaginationProps['onChange'] = useCallback((current: number, pageSize: number) => {
    getRecord(current - 1, pageSize);
    setCurrent(current - 1);
    setPageSize(pageSize);
  }, [getRecord]);

  const values: any = React.useMemo(() => ({
    ...waybills,
    subClientId,
    setSelectedWaybill,
    selectedWaybill,
    setSubClientId,
    setSelectedRow,
    selectedRow,
  }), [subClientId, setSelectedWaybill, selectedWaybill, selectedRow, waybills])

  const onExportToExcelVehicleHandle = useCallback(() => {
    trackPromise(ExportCnDnToExcelAction({ pageNumber: current, pageSize, isDirectorConfirmedSet: false, isFinanceConfirmedSet: false, isCfoConfirmedSet: false, isDivisionHeadConfirmedSet: false }), "download-file-area");
  }, [
    ExportCnDnToExcelAction
  ]);

  return (
    <CreditNoteContext.Provider value={values}>
      <Typography.Title level={4} >  CN\DN request screen  </Typography.Title>
      <SearchComponent />
      <PaginatedTableComponent
        columns={columns}
        data={waybills ?? []}
        rowKey='id'
        current={current + 1}
        pageSize={pageSize}
        total={total}
        onPaginationChange={onPaginationChange}
        expandable={{
          expandedRowRender: (record: ICreditNoteWaybills, index, indent, expanded: boolean, fromSource: string = 'request') => (record) ? expandedRowRender(record, index, indent, expanded, fromSource) : null,
          expandedRowClassName, columnWidth: 5, columnTitle: '', indentSize: 5,
          rowExpandable: (record: ICreditNoteWaybills) => !!record?.childNode?.length
        }}
        isLoading={getCNProgress || getCreditNotePrintProgress}
        isRefresh
        onRefreshHandle={onRefreshHandler}
      >
        <Row justify={'end'}>
          <BtnComponent onClickHandler={onClickHandler} label={'CN/ DN Request'}
            hidden={isProdMode() ? !isAccessible([UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER, UserEnum.ADMIN]) : !isAccessible([UserEnum.MANAGER, UserEnum.MANAGER])} />
        </Row>
        <ExportVehicleToExcelComponent
          onExportToExcelVehicleHandle={onExportToExcelVehicleHandle}
        />
      </PaginatedTableComponent>
      {open ? <CreditNoteCreateComponent open={open} onClose={(value) => setOpen(value)} /> : null}
    </CreditNoteContext.Provider>

  )
}